/* JOLLYJOY — reveal-on-scroll animations.
   Adds .jj-visible to .jj-reveal elements as they enter the
   viewport. Falls back to showing everything if
   IntersectionObserver is unavailable. Motion preferences are
   handled in jollyjoy.css. */
(function () {
  var els = document.querySelectorAll('.jj-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('jj-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('jj-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  els.forEach(function (el) { observer.observe(el); });
})();
